import { forwardRef, type CSSProperties } from 'react';
import classNames from 'classnames';
import styles from './FJAutoLoading.module.less';
import FJLoading from './FJLoading';

interface FJAutoLoadingProps {
    shown?: boolean;
    innerStyle?: CSSProperties;
    style?: CSSProperties;
    strokeColor?: string;
    className?: string;
}

const FJAutoLoading = forwardRef<HTMLDivElement, FJAutoLoadingProps>(function FJAutoLoading(
    { shown, innerStyle, style, strokeColor, className },
    ref,
) {
    return (
        <div className={classNames(styles.container, shown && styles.active, className)} ref={ref} style={style}>
            <FJLoading style={innerStyle} strokeColor={strokeColor} />
        </div>
    );
});

export default FJAutoLoading;
